/* eslint-disable max-len */
import { DOMAIN } from 'constants/api';


export const TEXT = 'Для хранения результатов Вашего участия и формирования подтверждающих документов необходимо Ваше согласие на обработку персональных данных и, в случаях предусмотренных некоторыми Положениями, передача данных третьим лицам. (Например, для включения сведений об участии в Конференции в Федеральной системе).';
export const LINK = `https://${DOMAIN}/files/oferta_sogl_pnd.docx`;
